import React, { useState } from "react";
import Modal from "components/UI/DialogModal";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { useTranslation } from "react-i18next";
import { IJob } from "models/job";
import { useAlert } from "contexts/alertContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { ICompanyJob } from "models/companyJob";
import { ICompanyDepartments } from "models/companyDepartment";

interface Props {
  open: boolean;
  companyJobs: ICompanyJob[];
  loading: boolean;
  Departments: ICompanyDepartments[];
  Jobs: IJob[];
  onClose: () => void;
  onSubmit: (data: any[], department: string) => void;
}

type Entry = {
  Name: string;
  NameAr: string;
};

function isDepartmentJobCombinationFound(
  data: ICompanyJob[],
  selectedDepartmentId: string,
  selectedJobId: string
) {
  for (const item of data) {
    if (
      item.companyDepartmentId === selectedDepartmentId &&
      item.jobId === selectedJobId
    ) {
      return true;
    }
  }

  return false;
}


const isTiTleExist = (  data: ICompanyJob[], title: string, titleAr: string) => {
for (const item of data) {
  if (
    item?.name?.trim().toLocaleLowerCase() === title.trim().toLocaleLowerCase() ||
    item?.nameAr?.trim() === titleAr.trim()
  ) {
    return true;
  }
}}

const AddCompanyJob: React.FC<Props> = ({
  open,
  loading,
  Departments,
  Jobs,
  onClose,
  onSubmit,
  companyJobs,
}) => {
  const { t } = useTranslation();
  
  const [department, setDepartment] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [titleAr, setTitleAr] = useState<string>("");
  const [entries, setEntries] = useState<Entry[]>([]);
  const { setAlert } = useAlert();
  const departmentsOptions = Departments.map((department) => ({
    value: department.id,
    label: department.name,
  }));

  const handleAddEntry = () => {
    
      if (!isTiTleExist(companyJobs, title, titleAr)) {
        const newEntry = {  Name: title, NameAr: titleAr };
        setEntries([...entries, newEntry]);
        setTitle("");
        setTitleAr("");
      } else {
        setAlert({
          open: true,
          message: "Title or TitleAr Already Exists",
          type: "info",
        });
      }
    

    

  };

  const handleDeleteEntry = (index: number) => {
    const newEntries = entries.filter((_, i) => i !== index);
    setEntries(newEntries);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={t("T_add_job")}
        maxWidth="lg"
        children={
          <Stack spacing={2} p={2}>
            <div>
              <Select
                value={department}
                onChange={(e) => setDepartment(e.target.value as string)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  {t("T_department")}
                </MenuItem>
                {departmentsOptions.map((dep) => (
                  <MenuItem key={dep.value} value={dep.value}>
                    {dep.label}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >

                <TextField
                  label={t("T_title")}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                <TextField
                  label={t("T_title_Ar")}
                  value={titleAr}
                  onChange={(e) => setTitleAr(e.target.value)}
                />
                <Button
                  variant="contained"
                  style={{ borderRadius: 0 }}
                  onClick={handleAddEntry}
                  disabled={!title || !titleAr}
                >
                  {t("T_add")}
                </Button>
              </div>

              <Table>
                <TableHead>
                  <TableRow>
                  
                    <TableCell>{t("T_title")}</TableCell>
                    <TableCell>{t("T_title_Ar")}</TableCell>
                    <TableCell>{t("T_action")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {entries.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>{entry.Name}</TableCell>
                      <TableCell>{entry.NameAr}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleDeleteEntry(index)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Stack>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
              {t("T_cancel")}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={() => onSubmit(entries, department)}
            >
              {t("T_add")}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default AddCompanyJob;
